import { connect } from 'react-redux'
import { withCookies } from 'react-cookie'
/*
import {loadAddressList,deleteAddress,loadAddressListMyReservationForCustIdSecure, loadAddressListMyReservationForCustId} from './actionspwa/svaddresslistActions'
import Addresses from './components/accountsabode/accountcontainer/addresses'
*/
import {loadReguserDet, addReguserNow} from './redux/svractions/svreguserdetActions'
import SVReguserContainer from './components/accountsabode/accountcontainer/reguserContainer'

import {loadStoredcardListMyReservationForCustId,loadStoredcardListMyReservationForCustIdSecure, loadStoredcardList} from './redux/svractions/svstoredcardlistActions'
import Storedcards from './components/accountsabode/accountcontainer/storedCards'


import {loadReguserList,deleteReguser} from './redux/svractions/svreguserlistActions'
import Regusers from './components/accountsabode/accountcontainer/regusers'

import {addPwrresetNow} from './redux/svractions/svpwrresetActions'
import SVPwrresetContainer from './components/accountsabode/accountcontainer/pwrresetContainer'


import {loadUserProfileByCustIdNow,authenticateUsercredNow,clearformUsercred,svlogoutAction} from './redux/svractions/svusercreddetActions'
//import SVLoginabodeContainer from  './components/accountsabode/accountcontainer/loginAbodeContainer'
import SVProfilecosmosContainer from './components/accountsabode/accountcontainer/profileCosmosContainer'

import withCustomerStoredcardsHOC from './components/sojourns/withCustomerStoredcardsHOC';
import withCustomerAddressesHOC from './components/sojourns/withCustomerAddressesHOC';


/*
import {createResetFlagsStoredcardDet,loadStoredcardDet,loadStoredcardDetSecure,addStoredcardNow,addStoredcardNowSecure,svLoadStoredcarddetReset} from './redux/svractions/svstoredcarddetActions'
import StoredcardContainer from  './components/accountsabode/accountcontainer/storedcardContainer'


import {loadReguserList,deleteReguser} from './redux/svractions/svreguserlistActions'

import Regusers from './components/accountsabode/accountcontainer/regusers'

*/
import {createResetFlagsStoredcardDet,loadStoredcardDet,loadStoredcardDetSecure,addStoredcardNow,addStoredcardNowSecure,svLoadStoredcarddetReset} from './redux/svractions/svstoredcarddetActions'
import StoredcardContainer from  './components/accountsabode/accountcontainer/storedcardContainer'

/*SVADDRESSLIST start*/

import {loadAddressList,deleteAddress,loadAddressListMyReservationForCustIdSecure, loadAddressListMyReservationForCustId} from './redux/svractions/svaddresslistActions'
import Addresses from './components/accountsabode/accountcontainer/addresses'

import {loadAddressDet, loadAddressDetSecure,addAddressNow,addAddressNowSecure, createResetFlagsAddressDet} from './redux/svractions/svaddressdetActions'
import AddressContainer from './components/accountsabode/accountcontainer/addressContainer'

import OrderContainer from  './components/ordersabode/ordercontainer/orderBoard'
import {ordAndImagesSV, ordAndImagesSVSecure,getSoDetails} from './redux/svractions/svesorderActions'

import {loadOrderderNow, loadOrderderNowSecure} from './redux/svractions/svorderdetActions'
import OrderDetail from './components/ordersabode/ordercontainer/orderDetail'

import {getPriceAndTexSuccess,loadReviewNowMyReservationForCustId, priceAndTexNow, priceAndTexNowSecure, saveTravellerReviewSuccess, loadReviewNow, svLoadReviewdetReset} from './redux/svractions/svreviewActions'
import {loadReviewNowSJReservationForCustId,sjpriceAndTexNow, sjpriceAndTexNowSecure,saveTravellerSJReviewSuccess,loadSJReviewNow} from  './redux/svractions/shreviewActions'
//mar18
/*svapr15 start*/
import {crSaveErrorTocumentReview,crSaveTocumentReviewSuccess,crSaveDocumentReviewSuccess,loadReviewNowCRReservationForCustId,crpriceAndTexNow, crpriceAndTexNowSecure,saveTravellerCRReviewSuccess,loadCRReviewNow} from  './redux/svractions/svcrreviewActions'

import {pbsaveTravellerSJReviewSuccess} from  './redux/svractions/sjpbreviewActions'
import FinalStepPaymentReviewContainer from './components/sojourns/SVReview'
import SJReviewContainer from './components/sojourns/SJReview'

import SJCliReviewContainer from './components/sojourns/SJCliReview'

import SJPBReviewContainer from './components/sojourns/SJPBReview'

import {sojAndImagesSV, sojAndImagesSVFacet} from './redux/svractions/svessearchActions'
//import {sojAndImagesSV, sojAndImagesSVFacet} from './redux/svractions/sojsearchActions'
import {sojAndImagesSojourn,sojAndImagesSojournMore,sojAndImagesSojournPaginate,sojAndImagesSojournFacet,saveRoomSuccess} from './redux/svractions/sojsearchActions'
import SojSearchBoardContainer from './components/graphs/escontainer/sojBoard'
/*svdec15 start*/
/* not used delete
import {cliAndImagesCruise} from './redux/svractions/clisearchActions'
*/
import CliSearchBoardContainer from './components/graphs/eccontainer/cliBoard'
/*svdec15 end*/
import InvSearchBoardContainer from './components/graphs/sojcontainer/invBoard'
import PbSearchBoardContainer from './components/graphs/sjpbcontainer/pbBoard'


import {getFacetDataDefaultFromServer, saveFacetFilterCheckSuccess}     from './redux/svractions/svfacetActions'
import FindBar from './components/esfind/FindBar'


import PbSearchBar from './components/pbfind/PbSearchBar'
import InvSearchBar from './components/sojfind/InvSearchBar'
import SojSearchBar from './components/esfind/SojSearchBar'
import FacetBar from './components/esfind/FacetBar'
import InvFacetBar from './components/sojfind/InvFacetBar'
import {getInvFacetDataDefaultFromServer, saveInvFacetFilterCheckSuccess}     from './redux/svractions/invfacetActions'

import {getLocationDataDefaultFromServer,esautocompleteNow} from './redux/svractions/svlocationdataActions'

//sojAndImagesSojournPaginate1HotelById


//cosmos  inetflightsearch


import {flySaveMcitytReviewSuccess,flyAndImagesSV, flyCountryCodeSV,flyAndImagesSVFacet, saveFindEsQueryDataSuccess, saveUserOffer} from './redux/svractions/svflysearchActions'
import FlySearchBoardContainer from './components/flytrident/flycontainer/flyBoard'

import {getFlyFacetDataDefaultFromServer, saveFlyFacetFilterCheckSuccess} from './redux/svractions/svflyfacetActions'
import FlyFacetBar from './components/flyfind/FlyFacetBar'

import FlySearchBar from './components/flyfind/FlySearchBar'
/*svdec18 start*/
import {cliCountryCodeSV,cliAndImagesSV,cliAndImagesSojournMore, saveFindCliEsQueryDataSuccess} from './redux/svractions/svclisearchActions'

import CliSearchBar from './components/clifind/CliSearchBar'

/*svmar28 start*/


import {tpordAndImagesSV,tpordAndImagesSVSecure,deleteItn} from  './redux/svractions/svtporderActions'
import TpOrderContainer from  './components/ordersfly/topordercontainer/tporderBoard'


import {loadTpOrderderNow, loadTpOrderderNowSecure} from './redux/svractions/svtporderdetActions'
import TpOrderDetail from './components/ordersfly/topordercontainer/tporderDetail'


import {flyLoadReviewNowMyReservationForCustId, flypriceAndTexNow, flypriceAndTexNowSecure, flySaveTravellerReviewSuccess,flySaveDocumentReviewSuccess,flySaveTocumentReviewSuccess, flyLoadReviewNow} from './redux/svractions_cosmos/svflyreviewActions_cosmos'
import FlyFinalStepPaymentReviewContainer from './components/sojourns/SVFlyReview'

/*svmar28 end*/
import withCustomerSpacesHOC from './components/sojourns/withCustomerSpacesHOC'
import withCustomerReviewHOC from './components/sojourns/withCustomerReviewHOC'
import withCustomerReserveHOC from './components/sojourns/withCustomerReserveHOC';
/*svdec20* 2025 */
import withCustomerCruisesHOC from './components/sojourns/withCustomerCruisesHOC'

import withCustomerSJReviewHOC from './components/sojourns/withCustomerSJReviewHOC'
import withCustomerSJReserveHOC from './components/sojourns/withCustomerSJReserveHOC';
//sjjul14

//sjauj1 start
import withCustomerSJPBReviewHOC from './components/sojourns/withCustomerSJPBReviewHOC'

//sjaug1 end
import withCustomerSJHotelHOC from './components/sojourns/withCustomerSJHotelHOC'

import withCustomerFlySpacesHOC from './components/sojourns/withCustomerFlySpacesHOC';
import withCustomerFlyReviewHOC from './components/sojourns/withCustomerFlyReviewHOC';
import withCustomerFlyReserveHOC from './components/sojourns/withCustomerFlyReserveHOC';

//sjjun30
import InvTerrainContainer from './components/graphs/sojcontainer/InvTerrain'
import {sojAndImagesSojournPaginate1HotelById, svWrappedfetchTaskActionCreator, svwithImagesWrappedfetchTaskActionCreator,getSojournDetails, sojDetailsAndImagesSV} from './redux/svractions/sjsojournActions'
//CliTerrainContainer

/*svdev19*/
import CliTerrainContainer from './components/graphs/eccontainer/CliTerrain'
import {cliAndImagesCruisePaginate1HotelById} from './redux/svractions/svcruisedetActions'

//import {sojAndImagesSojournPaginate1HotelById, svWrappedfetchTaskActionCreator, svwithImagesWrappedfetchTaskActionCreator} from './redux/svractions/sjsojournActions'
/*svjul17 start*/
import {cliAndImagesFarelById} from './redux/svractions/svcruisefareActions'
import withCustomerFaresHOC from './components/sojourns/withCustomerFaresHOC'
import CliFareTerrainContainer from './components/graphs/eccontainer/CliFareTerrain'


/*

const mapStateToPropsAddresses= state => {
    console.log('--*********************svgot state star')
    console.log(state)
   
    const { svaddresslistView} = state
    console.log('--*********************svgot state svaddresslistView start')
    console.log(svaddresslistView )
  

  
   console.log('--*********************svgot state svaddresslistView end')
    
    return svaddresslistView
  }
const mapDispatchToPropsAddresses = dispatch => ({
    loadAddressList:(nameQParam)=>dispatch(loadAddressList(nameQParam)),
    
    loadAddressListMyReservationForCustIdSecure:(nameQParam, svcustProfile,svtv)=>dispatch(loadAddressListMyReservationForCustIdSecure(nameQParam,svcustProfile,svtv)),
    
    loadAddressListMyReservationForCustId:(nameQParam, svcustProfile)=>dispatch(loadAddressListMyReservationForCustId(nameQParam,svcustProfile)),
    
    svWrappedDeleteAddressActionCreator:(id)=>dispatch(deleteAddress(id))
})


const AddressesComSV = connect(mapStateToPropsAddresses, mapDispatchToPropsAddresses )(Addresses);

let AddressesComTmp = AddressesComSV
export const AddressesCom =AddressesComTmp
*/

/*profile detail start */

const mapStateToPropsReguser= state => {
    console.log('--*********************svgot state star')
    console.log(state)
   
    const { svreguserdetView} = state
    console.log('--*********************svgot state svaddressdetView start')
    console.log(svreguserdetView)
    console.log('--*********************svgot state svaddressdetView end')
    
   
    return svreguserdetView
  }
const mapDispatchToPropsReguser = dispatch => ({
    loadReguserDet:(nameQParam)=>dispatch(loadReguserDet(nameQParam)),
    addReguserNow:(rqValues)=>dispatch(addReguserNow(rqValues))
})
export const ReguserContainerCom = 
   connect(
       mapStateToPropsReguser, 
        mapDispatchToPropsReguser
        
    )(SVReguserContainer);
/*
export const ReguserContainerCom = 
   connect(
       mapStateToPropsReguser, 
        mapDispatchToPropsReguser, 
        null, 
        {withRef:true}
    )(SVReguserContainer);
*/
/*profile detail end us node 86 non secure  */

/*sv pwreset start*/

const mapStateToPropsPwrreset= state => {
  console.log('--*********************svgot state svpwrresetView')
  console.log(state)
  /*
  const {svessearch} = state
  console.log(svessearch)
  console.log('--*********************svgot state end')
 
  return svessearch
  */
  const { svpwrresetView} = state
  console.log('--*********************svgot state svpwrresetView start')
  console.log(svpwrresetView)
  console.log('--*********************svgot state svpwrresetView end')
  
 
  return svpwrresetView
}
const mapDispatchToPropsPwrreset = dispatch => ({
  
  addPwrresetNow:(rqValues)=>dispatch(addPwrresetNow(rqValues))
})

export const PwrresetContainerCom = connect(mapStateToPropsPwrreset, mapDispatchToPropsPwrreset,null,{ forwardRef: true})(SVPwrresetContainer);



/*sv pwrreet end*/

/*SVREGUSERLIST start*/
  

const mapStateToPropsRegusers= state => {
  console.log('--*********************svgot state star')
  console.log(state)
  /*
  const {svessearch} = state
  console.log(svessearch)
  console.log('--*********************svgot state end')
 
  return svesseaSVOrderdetComrch
  */
  const { svreguserlistView} = state
  console.log('--*********************svgot state svreguserlistView start')
  console.log(svreguserlistView)
  console.log('--*********************svgot state svreguserlistView end')
  
 
  return svreguserlistView
}
const mapDispatchToPropsRegusers = dispatch => ({
  loadReguserList:(nameQParam)=>dispatch(loadReguserList(nameQParam)),
  svWrappedDeletereguserActionCreator:(id)=>dispatch(deleteReguser(id))
})

export const RegusersCom = connect(mapStateToPropsRegusers, mapDispatchToPropsRegusers ,null,{ withRef: true})(Regusers);

/*SVREGUSERLIST end*/
/*svfeb13 start*/

/*svusercredorg start

const mapStateToPropsUsercred= state => {
  console.log('--*********************svgot state star')
  console.log(state)
  
  
  const { svusercreddetView} = state
  console.log('--*********************svgot state svusercreddetView start')
  console.log(svusercreddetView)
  console.log('--*********************svgot state svusercreddetView end')
  
 
  return svusercreddetView
}
const mapDispatchToPropsUsercred = dispatch => ({
  
  clearformUsercred:()=>dispatch(clearformUsercred()),
  svlogoutAction:()=>dispatch(svlogoutAction()),
  authenticateUsercredNow:(rqValues)=>dispatch(authenticateUsercredNow(rqValues))
})



const LoginabodeContainerComSV = connect(mapStateToPropsUsercred, mapDispatchToPropsUsercred )(LoginabodeContainerCom);

let LoginabodeContainerComTmp =  withCookies(LoginabodeContainerComSV)
export const LoginabodeContainerCom =LoginabodeContainerComTmp

*/
/*svusercredorg end*/

/*svusercred start*/

const mapStateToPropsUsercred= state => {
  console.log('--*********************svgot state star')
  console.log(state)
  /*
  const {svessearch} = state
  console.log(svessearch)
  console.log('--*********************svgot state end')
 
  return svessearch
  */
  const { svusercreddetView} = state
  console.log('--*********************svgot state svusercreddetView start')
  console.log(svusercreddetView)
  console.log('--*********************svgot state svusercreddetView end')
  
 
  return svusercreddetView
}
const mapDispatchToPropsUsercred = dispatch => ({
  
  clearformUsercred:()=>dispatch(clearformUsercred()),
  svlogoutAction:()=>dispatch(svlogoutAction()),
  //loadUserProfileByCustIdNow
  loadUserProfileByCustIdNow:(rqValues)=>dispatch(loadUserProfileByCustIdNow(rqValues)),
  authenticateUsercredNow:(rqValues)=>dispatch(authenticateUsercredNow(rqValues))
})


/*
export const LoginabodeContainerCom = connect(mapStateToPropsUsercred, mapDispatchToPropsUsercred)(SVLoginabodeContainer);
*/ 
/*
const LoginabodeContainerComSV = connect(mapStateToPropsUsercred, mapDispatchToPropsUsercred ,null,{ withRef: true})(SVLoginabodeContainer);
*/
const ProfilecosmosContainerComSV = connect(mapStateToPropsUsercred, mapDispatchToPropsUsercred )(SVProfilecosmosContainer);
/*
export const ProfilecosmosContainerCom = ProfilecosmosContainerComSV
*/
let ProfilecosmosContainerComTmp =  withCookies(ProfilecosmosContainerComSV)
export const ProfilecosmosContainerCom =ProfilecosmosContainerComTmp


/*svusercred end*/

/*svcardet start 


const mapStateToPropsStoredcard= state => {
  console.log('--*********************svgot state star')
  console.log(state)
 
  const { svstoredcarddetView} = state
  console.log('--*********************svgot state svstoredcarddetView start')
  console.log(svstoredcarddetView)
  console.log('--*********************svgot state svstoredcarddetView end')
  
 
  return svstoredcarddetView
}
const mapDispatchToPropsStoredcard = dispatch => ({
  loadStoredcardDet:(nameQParam)=>dispatch(loadStoredcardDet(nameQParam)),
  loadStoredcardDetSecure:(nameQParam, svtk)=>dispatch(loadStoredcardDetSecure(nameQParam, svtk)),
  
  createResetFlagsStoredcardDet:()=>dispatch(createResetFlagsStoredcardDet()),
 
  addStoredcardNowSecure:(rqValues, svtv)=>dispatch(addStoredcardNowSecure(rqValues, svtv)),
  
  svLoadStoredcarddetReset:(rqValues)=>dispatch(svLoadStoredcarddetReset(rqValues)),
  addStoredcardNow:(rqValues)=>dispatch(addStoredcardNow(rqValues))
})


const StoredcardContainerComSV = connect(mapStateToPropsStoredcard, mapDispatchToPropsStoredcard)(StoredcardContainer);
let StoredcardContainerComTmp =  withCookies(StoredcardContainerComSV)
export const StoredcardContainerCom =StoredcardContainerComTmp
*/
/*svcarddet  end*/

/*svmar20 start */
/*storedcardliststart */

const mapStateToPropsStoredcards= state => {
  console.log('--*********************svgot state star')
  console.log(state)
  /*
  const {svessearch} = state
  console.log(svessearch)
  console.log('--*********************svgot state end')
 
  return svessearch
  */
  const { svstoredcardlistView} = state
 
 /*svj31 start 
   const { svstoredcardlistView, svusercreddetView} = state
  const {my_data_geo} = svusercreddetView
  console.log('--*********************svgot state svstoredcardlistView SVJ23 sv_data_geo start')
   console.log(my_data_geo)
  console.log(svstoredcardlistView)
  const {my_data_storedcard_confirmation,my_data_storedcarddet} = svstoredcardlistView
  console.log('--*********************svgot state svstoredcardlistView end')
  let svcob = {
      my_data_geo:my_data_geo,
      my_data_storedcard_confirmation:my_data_storedcard_confirmation,
      my_data_storedcarddet:my_data_storedcarddet,
  }
  return svcob
  */
  return svstoredcardlistView 

   /*svj31 end  return svstoredcardlistView */
}
const mapDispatchToPropsStoredcards = dispatch => ({
  loadStoredcardList:(nameQParam)=>dispatch(loadStoredcardList(nameQParam)),
  loadStoredcardListMyReservationForCustIdSecure:(nameQParam, svcustProfile ,svtv)=>dispatch(loadStoredcardListMyReservationForCustIdSecure(nameQParam,svcustProfile, svtv)),
  loadStoredcardListMyReservationForCustId:(nameQParam, svcustProfile)=>dispatch(loadStoredcardListMyReservationForCustId(nameQParam,svcustProfile)),
  
  svWrappedDeleteAddressActionCreator:(id)=>dispatch(deleteAddress(id))
})
/*
export const StoredcardsCom = connect(mapStateToPropsStoredcards, mapDispatchToPropsStoredcards)(Storedcards);
*/
const StoredcardsComSV = connect(mapStateToPropsStoredcards, mapDispatchToPropsStoredcards)(Storedcards);
let StoredcardsComTmp =  withCookies(StoredcardsComSV)
export const StoredcardsCom =StoredcardsComTmp

export const StoredcardsWithCustprofile = withCustomerStoredcardsHOC(StoredcardsCom);

/*storedcardlist end*/
/*svcardet start */


const mapStateToPropsStoredcard= state => {
  console.log('--*********************svgot state star')
  console.log(state)
  /*
  const {svessearch} = state
  console.log(svessearch)
  console.log('--*********************svgot state end')
 
  return svessearch
  */
  const { svstoredcarddetView} = state
  console.log('--*********************svgot state svstoredcarddetView start')
  console.log(svstoredcarddetView)
  console.log('--*********************svgot state svstoredcarddetView end')
  
 
  return svstoredcarddetView
}
const mapDispatchToPropsStoredcard = dispatch => ({
  loadStoredcardDet:(nameQParam)=>dispatch(loadStoredcardDet(nameQParam)),
  loadStoredcardDetSecure:(nameQParam, svtk)=>dispatch(loadStoredcardDetSecure(nameQParam, svtk)),
  /*svj31 start*/
  createResetFlagsStoredcardDet:()=>dispatch(createResetFlagsStoredcardDet()),
  /*svj31 end*/
  addStoredcardNowSecure:(rqValues, svtv)=>dispatch(addStoredcardNowSecure(rqValues, svtv)),
  
  svLoadStoredcarddetReset:(rqValues)=>dispatch(svLoadStoredcarddetReset(rqValues)),
  addStoredcardNow:(rqValues)=>dispatch(addStoredcardNow(rqValues))
})
/*
export const StoredcardContainerCom = connect(mapStateToPropsStoredcard, mapDispatchToPropsStoredcard)(StoredcardContainer);
*/

const StoredcardContainerComSV = connect(mapStateToPropsStoredcard, mapDispatchToPropsStoredcard)(StoredcardContainer);
let StoredcardContainerComTmp =  withCookies(StoredcardContainerComSV)
export const StoredcardContainerCom =StoredcardContainerComTmp

/*svcarddet  end*/

/*SVADDRESSLIST start*/
  

const mapStateToPropsAddresses= state => {
  console.log('--*********************svgot state star')
  console.log(state)
  /*
  const {svessearch} = state
  console.log(svessearch)
  console.log('--*********************svgot state end')
 
  return svessearch
  */
  const { svaddresslistView} = state
  console.log('--*********************svgot state svaddresslistView start')
  console.log(svaddresslistView )

  /*
  let svhobo = {
      svaddresslistView:svaddresslistView,
      svusercreddetView:svusercreddetView
  }
  
  console.log('--*********************svgot state svaddresslistView end')
  
 return svhobo
 */
/*
or
const { svaddresslistView, svusercreddetView} = state
  console.log('--*********************svgot state svaddresslistView start')
  console.log(svaddresslistView )
  console.log(svusercreddetView )
if(svusercreddetView && svusercreddetView.my_data_profile){
  svaddresslistView.svhobo = svusercreddetView.my_data_profile
}
console.log('--*********************svgot state svaddresslistView end')
  
  return svaddresslistView
*/

 console.log('--*********************svgot state svaddresslistView end')
  
  return svaddresslistView
}
const mapDispatchToPropsAddresses = dispatch => ({
  loadAddressList:(nameQParam)=>dispatch(loadAddressList(nameQParam)),
  
  loadAddressListMyReservationForCustIdSecure:(nameQParam, svcustProfile,svtv)=>dispatch(loadAddressListMyReservationForCustIdSecure(nameQParam,svcustProfile,svtv)),
  
  loadAddressListMyReservationForCustId:(nameQParam, svcustProfile)=>dispatch(loadAddressListMyReservationForCustId(nameQParam,svcustProfile)),
  
  svWrappedDeleteAddressActionCreator:(id)=>dispatch(deleteAddress(id))
})

/*
export const AddressesCom = connect(mapStateToPropsAddresses, mapDispatchToPropsAddresses)(Addresses);
*/
const AddressesComSV = connect(mapStateToPropsAddresses, mapDispatchToPropsAddresses)(Addresses);
let AddressesComTmp =  withCookies(AddressesComSV)
export const AddressesCom =AddressesComTmp

export const AddressesWithCustprofile = withCustomerAddressesHOC(AddressesCom);
/*SVADDRESSLIST end*/
/*svaddrdet start */


const mapStateToPropsAddress= state => {
  console.log('--*********************svgot state star')
  console.log(state)
  /*
  const {svessearch} = state
  console.log(svessearch)
  console.log('--*********************svgot state end')
 
  return svessearch
  j15,25 not needed
  const { svaddressdetView, svaddresslistView} = state
  
  console.log('--*********************SVJ15 svgot state svaddressdetView start')
  console.log(svaddressdetView)
  console.log(svaddresslistView)
 let sob = {...svaddressdetView}
 sob['my_data_geo'] = svaddresslistView.my_data_geo 
 console.log(sob)
  */
  const { svaddressdetView} = state
  
  console.log('--*********************SVJ15 svgot state svaddressdetView start')
  console.log(svaddressdetView)
  
  console.log('--*********************sSVJ15 vgot state svaddressdetView end')
  
 //return sob
  return svaddressdetView
}
const mapDispatchToPropsAddress = dispatch => ({
  loadAddressDet:(nameQParam)=>dispatch(loadAddressDet(nameQParam)),
  loadAddressDetSecure:(nameQParam,svtk)=>dispatch(loadAddressDetSecure(nameQParam,svtk)),
  addAddressNowSecure:(rqValues, svtv)=>dispatch(addAddressNowSecure(rqValues, svtv)),
  createResetFlagsAddressDet:()=>dispatch(createResetFlagsAddressDet()),
  addAddressNow:(rqValues)=>dispatch(addAddressNow(rqValues))
})
/*
export const AddressContainerCom = connect(mapStateToPropsAddress, mapDispatchToPropsAddress)(AddressContainer);
*/

const AddressContainerComSV = connect(mapStateToPropsAddress, mapDispatchToPropsAddress)(AddressContainer);
let AddressContainerComTmp =  withCookies(AddressContainerComSV)
export const AddressContainerCom =AddressContainerComTmp


/*svaddrdet  end*/

/*svmar20 end */

/*svesorder start */

const mapStateToPropsOrder= state => {
  console.log('--*********************svgot state star')
  console.log(state)
  /*
  const {svessearch} = state
  console.log(svessearch)
  console.log('--*********************svgot state end')
 
  return svessearch
  */
  const {svesorder, locationDataView} = state
  console.log(svesorder)
  console.log(locationDataView)
  console.log('--*********************svgot state end')
  const svmaster = {svesorder, locationDataView}
 
  return svmaster
}
const mapDispatchToPropsOrder = dispatch => ({
  getSoDetails:(nameQParam)=>dispatch(getSoDetails(nameQParam)),
  ordAndImagesSVSecure:(nameQParam, svtv)=>dispatch(ordAndImagesSVSecure(nameQParam , svtv)),
  ordAndImagesSV:(nameQParam)=>dispatch(ordAndImagesSV(nameQParam))
})

/*
export const SVESOrderCom = connect(mapStateToPropsOrder, mapDispatchToPropsOrder)(OrderContainer);
*/
const SVESOrderComSV  = connect(mapStateToPropsOrder, mapDispatchToPropsOrder)(OrderContainer);
let SVESOrderComTmp =  withCookies(SVESOrderComSV)
export const SVESOrderCom =SVESOrderComTmp



/*svesorder end*/

/**svorderdet start */
const mapStateToPropsOrderdet= state => {
  console.log('--*********************svgot state star')
  console.log(state)
  const {orderdetView} = state
  console.log(orderdetView)
  console.log('--*********************svgot state end')
 
  return orderdetView
}

const mapDispatchToPropsOrderdet = dispatch => ({
  
  svLoadReviewdetReset:(nameQParam)=>dispatch(svLoadReviewdetReset(nameQParam)),
  loadOrderderNow:(nameQParam)=>dispatch(loadOrderderNow(nameQParam)),
  loadOrderderNowSecure:(nameQParam,svtv)=>dispatch(loadOrderderNowSecure(nameQParam, svtv))
 
 
 
})
/*
export const SVOrderdetCom = connect(mapStateToPropsOrderdet, mapDispatchToPropsOrderdet)(OrderDetail);
*/


const SVOrderdetComSV = connect(mapStateToPropsOrderdet, mapDispatchToPropsOrderdet)(OrderDetail);
let SVOrderdetComTmp =  withCookies(SVOrderdetComSV)
export const SVOrderdetCom =SVOrderdetComTmp

/**svorderdet end */



/**svrewview start */


const mapStateToPropsReview= state => {
  console.log('--*********************svgot state star')
  console.log(state)
  const {reviewView} = state
  console.log(reviewView)
  console.log('--*********************svgot state end')
 
  return reviewView
}

const mapDispatchToPropsReview = dispatch => ({
  loadReviewNowMyReservationForCustId : (nameQParam, custProfile)=>dispatch(loadReviewNowMyReservationForCustId(nameQParam, custProfile)),
  loadReviewNow:(nameQParam)=>dispatch(loadReviewNow(nameQParam)),
  saveTravellerReviewSuccess:(pt)=>dispatch(saveTravellerReviewSuccess(pt)),
 
  priceAndTexNowSecure:(nameQParam,svtv)=>dispatch(priceAndTexNowSecure(nameQParam,svtv)),
  priceAndTexNow:(nameQParam)=>dispatch(priceAndTexNow(nameQParam))
 
})

/*
export const SVReviewTerrainCom = connect(mapStateToPropsReview, mapDispatchToPropsReview)(FinalStepPaymentReviewContainer);
*/
const SVReviewTerrainComSV = connect(mapStateToPropsReview, mapDispatchToPropsReview)(FinalStepPaymentReviewContainer);
let SVReviewTerrainComTmp =  withCookies(SVReviewTerrainComSV)
export const SVReviewTerrainCom =SVReviewTerrainComTmp

/**svrewview end */


// Render out products list with search feature

export const ReviewWithSearch = withCustomerReviewHOC(SVReviewTerrainCom);
export const ReserveWithSearch = withCustomerReserveHOC(SVReviewTerrainCom);

/**svrewview end */

/*may19 start*/

/**sjrewview start */


const mapStateToPropsSJReview= state => {
  console.log('--*********************svgot state sjreviewView star')
  console.log(state)
  const {sjreviewView} = state
  console.log(sjreviewView)
  console.log('--*********************svgot state sjreviewView end')
 
  return sjreviewView
}

const mapDispatchToPropsSJReview = dispatch => ({
  loadReviewNowSJReservationForCustId : (nameQParam, custProfile)=>dispatch(loadReviewNowSJReservationForCustId(nameQParam, custProfile)),
  loadSJReviewNow:(nameQParam)=>dispatch(loadSJReviewNow(nameQParam)),
  saveTravellerSJReviewSuccess:(pt)=>dispatch(saveTravellerSJReviewSuccess(pt)),
 
  sjpriceAndTexNowSecure:(nameQParam,svtv)=>dispatch(sjpriceAndTexNowSecure(nameQParam,svtv)),
  sjpriceAndTexNow:(nameQParam)=>dispatch(sjpriceAndTexNow(nameQParam))
 
})

/*
export const SVReviewTerrainCom = connect(mapStateToPropsSJReview, mapDispatchToPropsSJReview)(FinalStepPaymentReviewContainer);
*/
const SJReviewTerrainComSV = connect(mapStateToPropsSJReview, mapDispatchToPropsSJReview)(SJReviewContainer);
let SJReviewTerrainComTmp =  withCookies(SJReviewTerrainComSV)
export const SJReviewTerrainCom =SJReviewTerrainComTmp

/**sjrewview end */


// Render out products list with search feature

export const SJReviewWithSearch = withCustomerSJReviewHOC(SJReviewTerrainCom);
export const SJReserveWithSearch = withCustomerSJReserveHOC(SJReviewTerrainCom);


//export const FlyReserveWithSearch = withCustomerSpaceReserveHOC(SVFlyReviewTerrainCom);


/**sjrewview end */

/*may19 end*/

/*
export const  SVESSearchCom = connect(
    (state)=>{
     console.log('--svgot state')
     console.log(state)
    
     return state
   },
   
   dispatch=>({
       svWrappedfetchSVESSearchActionCreator:function(sojourns){
           console.log('redux sv store.dispatch ')
           dispatch(fetchSVESSearchActionCreator(sojourns))
       }
   
   })
   
   
    )(SojSearchBoardContainer)
   
*/

/*
const mapStateToProps= state => ({
    quarters:state.dropdownReducer.quarters,
    dropdownData:state.dropdownReducer.dropdownData,
    dropdownLoading:state.dropdownReducer.dropdownLoading,
    dropdownError:state.dropdownReducer.dropdownError
})
*/

const mapStateToProps= state => {
  console.log('--*********************svgot state star')
  console.log(state)
  
  const {svessearch, locationDataView} = state
  console.log(svessearch)
  console.log(locationDataView)
  console.log('--*********************svgot state end')
  const svmaster = {svessearch, locationDataView}
 
  return svmaster
}
const mapDispatchToProps = dispatch => ({
  getSoDetails:(nameQParam)=>dispatch(getSoDetails(nameQParam)),
  sojAndImagesSV:(nameQParam)=>dispatch(sojAndImagesSV(nameQParam))
})

  
export const SVESSearchCom = connect(mapStateToProps, mapDispatchToProps)(SojSearchBoardContainer);

export const SpacesWithCustprofile = withCustomerSpacesHOC(SVESSearchCom);


/*sv facetbarbuscom start */

const mapStateToFacetBarProps =  state => {
  console.log('--*********************svgot facet state star')
  console.log(state)
  const {facetDataView,svessearch} = state
  const {sv_esquery_data} = svessearch
  let svmaster = {
      facetDataView:facetDataView,
      myloc:svessearch.sv_esquery_data
  }
  console.log(svmaster)
  console.log(facetDataView)
  console.log('--*********************svgot facet state end')

  //return facetDataView
  return svmaster
}
const mapDispatchToPropsFacetBar= dispatch => ({
 getFacetDataDefaultFromServer:(nameQParam)=>dispatch(getFacetDataDefaultFromServer(nameQParam)),
 
 saveFacetFilterCheckSuccess:(ckData)=> dispatch(saveFacetFilterCheckSuccess(ckData)),
  
 sojAndImagesSVFacet:(esQuery, sv_esquery_data)=> dispatch(sojAndImagesSVFacet(esQuery, sv_esquery_data))
/* sojAndImagesSV:(esQuery,sojAndImagesSV)=> dispatch(sojAndImagesSV(esQuery,sojAndImagesSV)) */
 
 
})
export const FacetBarBusCom = connect(mapStateToFacetBarProps, mapDispatchToPropsFacetBar)(FacetBar);

/*sv facetbarbuscom end */
/*sv searchbarbuscom start */
const mapStateToFindBarProps =  state => {
  console.log('--*********************svgot state star')
  console.log(state)
  const {locationDataView} = state
  console.log(locationDataView)
  console.log('--*********************svgot state end')

  return locationDataView
}
const mapDispatchToPropsFindBar= dispatch => ({
  
 
  getLocationDataDefaultFromServer:(nameQParam)=>dispatch(getLocationDataDefaultFromServer(nameQParam)),
  esautocompleteNow:(esQuery)=> dispatch(esautocompleteNow(esQuery)),
  //flyAndImagesSV:(esQuery)=> dispatch(flyAndImagesSV(esQuery)),
  sojAndImagesSV:(esQuery,my_esqueryText)=> dispatch(sojAndImagesSV(esQuery,my_esqueryText))
 
 
})
export const SearchBarBusCom = connect(mapStateToFindBarProps, mapDispatchToPropsFindBar)(FindBar);


/*sv searchbarbuscom ebd */
/*svapr29 start*/
/*sv searchbarbuscom start */
const mapStateToSojSearchBarProps =  state => {
  console.log('--*********************svgot mapStateToSojSearchBarProps star')
  console.log(state)
  const {locationDataView} = state
  console.log(locationDataView)
  console.log('--*********************svgot mapStateToSojSearchBarProps end')

  return locationDataView
}
const mapDispatchToPropsSojSearchBar= dispatch => ({
  
 
  getLocationDataDefaultFromServer:(nameQParam)=>dispatch(getLocationDataDefaultFromServer(nameQParam)),
  esautocompleteNow:(esQuery)=> dispatch(esautocompleteNow(esQuery)),
  //flyAndImagesSV:(esQuery)=> dispatch(flyAndImagesSV(esQuery)),
  sojAndImagesSV:(esQuery,my_esqueryText)=> dispatch(sojAndImagesSV(esQuery,my_esqueryText))
 
 
})
export const SojSearchBarBusCom = connect(mapStateToSojSearchBarProps, mapDispatchToPropsSojSearchBar)(SojSearchBar);


/*sv searchbarbuscom ebd */
/*svapr29 end */

/*svfly start */

const mapFlyStateToProps= state => {
  console.log('--*********************svgot flyssearch state star')
  console.log(state)
  /*
  const {svflysearch} = state
  console.log(svessearch)
  console.log('--*********************svgot state end')
 
  return svessearch
  */
  const {svflysearch, locationDataView} = state
  console.log(svflysearch)
  console.log(locationDataView)
  console.log('--*********************svgot flyssearch state end')
  const svmaster = {svflysearch, locationDataView}
 
  return svmaster
}
const mapFlyDispatchToProps = dispatch => ({
 // getSoDetails:(nameQParam)=>dispatch(getSoDetails(nameQParam)),
 flySaveMcitytReviewSuccess:(svmcityOb)=>dispatch(flySaveMcitytReviewSuccess(svmcityOb)),
 saveUserOffer:(svob)=>dispatch(saveUserOffer(svob)),

 flyCountryCodeSV:(esQuery, svfly_esquery_data)=> dispatch(flyCountryCodeSV(esQuery, svfly_esquery_data)),

  flyAndImagesSV:(nameQParam)=>dispatch(flyAndImagesSV(nameQParam))
})

  
export const SVFlySearchComSV = connect(mapFlyStateToProps, mapFlyDispatchToProps)(FlySearchBoardContainer);
let SVFlySearchComTmp =  withCookies(SVFlySearchComSV)
export const SVFlySearchCom = SVFlySearchComTmp

export const FlyWithCustprofile = withCustomerFlySpacesHOC(SVFlySearchCom);


/*svfly end */

/*sv flyfacetbarbuscom start */


const mapStateToFlyFacetBarProps =  state => {
  console.log('--*********************svgot facet state star')
  console.log(state)
  const {flyfacetDataView, svflysearch} = state
  console.log(flyfacetDataView)
  console.log('--*********************svgot facet state end')
  let svflymaster = {
      flyfacetDataView:flyfacetDataView,
      myflyloc:svflysearch.svfly_esquery_data
  }
  console.log(svflymaster)

  //return flyfacetDataView
  return svflymaster
}
const mapDispatchToPropsFlyFacetBar= dispatch => ({
 getFlyFacetDataDefaultFromServer:(nameQParam)=>dispatch(getFlyFacetDataDefaultFromServer(nameQParam)),
 
 saveFlyFacetFilterCheckSuccess:(ckData)=> dispatch(saveFlyFacetFilterCheckSuccess(ckData)),
  
 flyAndImagesSVFacet:(esQuery, myflyloc_got)=> dispatch(flyAndImagesSVFacet(esQuery, myflyloc_got)),
 flyAndImagesSV:(esQuery, svfly_esquery_data)=> dispatch(flyAndImagesSV(esQuery, svfly_esquery_data))
 
 
})
export const SVFlyFacetBarBusCom = connect(mapStateToFlyFacetBarProps, mapDispatchToPropsFlyFacetBar)(FlyFacetBar);

/*sv flyfacetbarbuscom end */



/*sv flysearchbarbuscom start */
const mapStateToFlySearchFindBarProps =  state => {
  console.log('--*********************svgot state star')
  console.log(state)
  const {locationDataView, svflysearch} = state
  const {svfly_esquery_data} = svflysearch
  console.log(locationDataView)
  console.log('--*********************svgot state end')
  const {locationData} = locationDataView
  let master = {
      locationData:locationData,
      svfly_esquery_data:svfly_esquery_data

  }
  console.log(master)
  return master
  //return locationDataView
}
const mapDispatchToPropsFlySearchFindBar= dispatch => ({
  
 
  getLocationDataDefaultFromServer:(nameQParam)=>dispatch(getLocationDataDefaultFromServer(nameQParam)),
  esautocompleteNow:(esQuery)=> dispatch(esautocompleteNow(esQuery)),
  saveFindEsQueryDataSuccess:(findStateFilters)=>dispatch(saveFindEsQueryDataSuccess(findStateFilters)),
  flyCountryCodeSV:(esQuery, svfly_esquery_data)=> dispatch(flyCountryCodeSV(esQuery, svfly_esquery_data)),

  flyAndImagesSV:(esQuery, svfly_esquery_data)=> dispatch(flyAndImagesSV(esQuery, svfly_esquery_data)),
  sojAndImagesSV:(esQuery)=> dispatch(sojAndImagesSV(esQuery))
 
 
})
export const FlySearchBarBusCom = connect(mapStateToFlySearchFindBarProps, mapDispatchToPropsFlySearchFindBar)(FlySearchBar);


/*sv sflyearchbarbuscom end */

/*svmar28 start*/
/*svtporder fly  start */


const mapStateToPropsTPOrder= state => {
  console.log('--*********************svgot  svtporder state star')
  console.log(state)
  const {svtporder, locationDataView} = state
  console.log(svtporder)
  console.log(locationDataView)
  console.log('--*********************svgot svtporder state end')
  const svmaster = {svtporder, locationDataView}
 
  return svmaster
}
const mapDispatchToPropsTPOrder = dispatch => ({
 
  tpordAndImagesSVSecure:(nameQParam, svtv)=>dispatch(tpordAndImagesSVSecure(nameQParam , svtv)),
  tpordAndImagesSV:(nameQParam)=>dispatch(tpordAndImagesSV(nameQParam)),
  svWrappedDeleteItnActionCreator:(id)=>dispatch(deleteItn(id))
  
})


const SVTPOrderComSV  = connect(mapStateToPropsTPOrder, mapDispatchToPropsTPOrder)(TpOrderContainer);
let SVTPOrderComTmp =  withCookies(SVTPOrderComSV)
export const SVTPOrderCom =SVTPOrderComTmp




/*svtporder end*/

/*svtporderdet start */

const mapStateToPropsTpOrderdet= state => {
  console.log('--*********************svgot state  tporderdetView star')
  console.log(state)
  const {tporderdetView} = state
  console.log(tporderdetView)
  console.log('--*********************svgot state tporderdetView end')
 
  return tporderdetView
}

const mapDispatchToPropsTpOrderdet = dispatch => ({
  
  //svLoadReviewdetReset:(nameQParam)=>dispatch(svLoadReviewdetReset(nameQParam)),
  loadTpOrderderNow:(nameQParam)=>dispatch(loadTpOrderderNow(nameQParam)),
  loadTpOrderderNowSecure:(nameQParam,svtv)=>dispatch(loadTpOrderderNowSecure(nameQParam, svtv))
 
 
 
})


const SVTpOrderdetComSV = connect(mapStateToPropsTpOrderdet, mapDispatchToPropsTpOrderdet)(TpOrderDetail);
let SVTpOrderdetComTmp =  withCookies(SVTpOrderdetComSV)
export const SVTpOrderdetCom =SVTpOrderdetComTmp


/*svtporderdet end*/

/*svflyreview start**** */


const mapStateToPropsFlyReview= state => {
  console.log('--*********************svgot state star')
  console.log(state)
  const {flyreviewView} = state
  console.log(flyreviewView)
  console.log('--*********************svgot state end')
 
  return flyreviewView
}

const mapDispatchToPropsFlyReview = dispatch => ({
  flyLoadReviewNowMyReservationForCustId : (nameQParam, custProfile)=>dispatch(flyLoadReviewNowMyReservationForCustId(nameQParam, custProfile)),
  flyLoadReviewNow:(nameQParam)=>dispatch(flyLoadReviewNow(nameQParam)),
  flySaveTravellerReviewSuccess:(pt)=>dispatch(flySaveTravellerReviewSuccess(pt)),
  flySaveDocumentReviewSuccess:(pt)=>dispatch(flySaveDocumentReviewSuccess(pt)),
  flySaveTocumentReviewSuccess:(pt)=>dispatch(flySaveTocumentReviewSuccess(pt)),
 
  flypriceAndTexNowSecure:(nameQParam,svtv)=>dispatch(flypriceAndTexNowSecure(nameQParam,svtv)),
  flypriceAndTexNow:(nameQParam)=>dispatch(flypriceAndTexNow(nameQParam))
 
})

/*
export const SVReviewTerrainCom = connect(mapStateToPropsReview, mapDispatchToPropsReview)(FinalStepPaymentReviewContainer);
*/
const SVFlyReviewTerrainComSV = connect(mapStateToPropsFlyReview, mapDispatchToPropsFlyReview)(FlyFinalStepPaymentReviewContainer);
let SVFlyReviewTerrainComTmp =  withCookies(SVFlyReviewTerrainComSV)
export const SVFlyReviewTerrainCom =SVFlyReviewTerrainComTmp


export const FlyReviewWithSearch = withCustomerFlyReviewHOC(SVFlyReviewTerrainCom);
export const FlyReserveWithSearch = withCustomerFlyReserveHOC(SVFlyReviewTerrainCom);


/*svflyreview end***** */
 
/*svmar28 end*/

/*svmay2 start*/

/*sv searchbarbuscom start */
/*
const mapStateToInvSearchBarProps =  state => {
  console.log('--*********************svgot mapStateToInvSearchBarProps star')
  console.log(state)
  const {locationDataView} = state
  console.log(locationDataView)
  console.log('--*********************svgot mapStateToInvSearchBarProps end')

  return locationDataView
}
const mapDispatchToPropsInvSearchBar= dispatch => ({
  
 
  getLocationDataDefaultFromServer:(nameQParam)=>dispatch(getLocationDataDefaultFromServer(nameQParam)),
  esautocompleteNow:(esQuery)=> dispatch(esautocompleteNow(esQuery)),
  //flyAndImagesSV:(esQuery)=> dispatch(flyAndImagesSV(esQuery)),
  sojAndImagesSV:(esQuery,my_esqueryText)=> dispatch(sojAndImagesSV(esQuery,my_esqueryText))
 
 
})
export const InvSearchBarBusCom = connect(mapStateToInvSearchBarProps, mapDispatchToPropsInvSearchBar)(InvSearchBar);


const mapStateToProps= state => {
  console.log('--*********************svgot state star')
  console.log(state)
  
  const {svessearch, locationDataView} = state
  console.log(svessearch)
  console.log(locationDataView)
  console.log('--*********************svgot state end')
  const svmaster = {svessearch, locationDataView}
 
  return svmaster
}
const mapDispatchToProps = dispatch => ({
  getSoDetails:(nameQParam)=>dispatch(getSoDetails(nameQParam)),
  sojAndImagesSV:(nameQParam)=>dispatch(sojAndImagesSV(nameQParam))
})

  
export const SVESSearchCom = connect(mapStateToProps, mapDispatchToProps)(InvSearchBoardContainer);

export const SpacesWithCustprofile = withCustomerSpacesHOC(SVESSearchCom);

*/
/*svmay2 end */

/*svmay3 start*/

/*sv searchbarbuscom start */
const mapStateToInvSearchBarProps =  state => {
  console.log('--*********************svgot mapStateToInvSearchBarProps star')
  console.log(state)
  const {locationDataView} = state
  console.log(locationDataView)
  console.log('--*********************svgot mapStateToInvSearchBarProps end')

  return locationDataView
}
const mapDispatchToPropsInvSearchBar= dispatch => ({
  
 //sojAndImagesSojournPaginate
  getLocationDataDefaultFromServer:(nameQParam)=>dispatch(getLocationDataDefaultFromServer(nameQParam)),
  esautocompleteNow:(esQuery)=> dispatch(esautocompleteNow(esQuery)),

  sojAndImagesSojournMore:(esQuery,my_esqueryText)=> dispatch(sojAndImagesSojournMore(esQuery,my_esqueryText)),
  sojAndImagesSojournPaginate:(esQuery,my_esqueryText)=> dispatch(sojAndImagesSojournPaginate(esQuery,my_esqueryText)),

  saveRoomSuccess:(roomData)=> dispatch(saveRoomSuccess(roomData)),
  //flyAndImagesSV:(esQuery)=> dispatch(flyAndImagesSV(esQuery)),
  sojAndImagesSojourn:(esQuery,my_esqueryText)=> dispatch(sojAndImagesSojourn(esQuery,my_esqueryText))
 
 
})
export const InvSearchBarBusCom = connect(mapStateToInvSearchBarProps, mapDispatchToPropsInvSearchBar)(InvSearchBar);


/*sojboard invBoard start

const mapStateToSOJINVProps= state => {
  console.log('--*********************svgot state star')
  console.log(state)
 
  const {sosjournsearch, locationDataView} = state
  console.log(sosjournsearch)
  console.log(locationDataView)
  console.log('--*********************svgot state end')
  const svmaster = {sosjournsearch, locationDataView}
 
  return svmaster
}
const mapDispatchToSOJINVProps = dispatch => ({
  getSoDetails:(nameQParam)=>dispatch(getSoDetails(nameQParam)),
  sojAndImagesSojourn:(nameQParam)=>dispatch(sojAndImagesSojourn(nameQParam))
})

  
export const SOJINVSearchComSV = connect(mapStateToSOJINVProps, mapDispatchToSOJINVProps)(InvSearchBoardContainer);

let SOJINVSearchComTmp =  withCookies(SOJINVSearchComSV)
export const SOJINVSearchCom = SOJINVSearchComTmp

export const SOJINVWithCustprofile = withCustomerSpacesHOC(SOJINVSearchCom);
*/

const mapStateToSOJINVProps= state => {
  console.log('--*********************svgot state star')
  console.log(state)
 
  const {sosjournsearch, locationDataView} = state
  console.log(sosjournsearch)
  console.log(locationDataView)
  console.log('--*********************svgot state end')
  const svmaster = {sosjournsearch, locationDataView}
 
  return svmaster
}
//sojAndImagesSojournPaginate
const mapDispatchToSOJINVProps = dispatch => ({
  getSoDetails:(nameQParam)=>dispatch(getSoDetails(nameQParam)),
  sojAndImagesSojournMore:(esQuery,my_esqueryText)=> dispatch(sojAndImagesSojournMore(esQuery,my_esqueryText)),
  sojAndImagesSojournPaginate:(esQuery,my_esqueryText)=> dispatch(sojAndImagesSojournPaginate(esQuery,my_esqueryText)),

  sojAndImagesSojourn:(nameQParam)=>dispatch(sojAndImagesSojourn(nameQParam))
})

  
export const  SOJINVSearchComSV = connect(mapStateToSOJINVProps, mapDispatchToSOJINVProps)(InvSearchBoardContainer);
let SOJINVSearchComTmp =  withCookies(SOJINVSearchComSV)

export const SOJINVSearchCom = SOJINVSearchComTmp


export const SOJINVWithCustprofile = withCustomerSpacesHOC(SOJINVSearchCom);

/*svdec15 start*/
const mapStateToSVRCLIProps= state => {
  console.log('--*********************svgot state star')
  console.log(state)
 
  const {cruisesearch, locationDataView} = state
  console.log(cruisesearch)
  console.log(locationDataView)
  console.log('--*********************svgot state end')
  const svmaster = {cruisesearch, locationDataView}
 
  return svmaster
}
//sojAndImagesSojournPaginate
const mapDispatchToSVRCLIProps = dispatch => ({
  getSoDetails:(nameQParam)=>dispatch(getSoDetails(nameQParam)),
  cliAndImagesSojournMore:(esQuery,my_esqueryText)=> dispatch(cliAndImagesSojournMore(esQuery,my_esqueryText)),
  /*svmar14 start */
  cliCountryCodeSV:(sojPostRqFromPage, svfly_esquery_data)=> dispatch(cliCountryCodeSV(sojPostRqFromPage, svfly_esquery_data)),
 /*svmar14 end */
  cliAndImagesSV:(esQuery, svcli_esquery_data)=> dispatch(cliAndImagesSV(esQuery, svcli_esquery_data)),
 // cliAndImagesCruise:(nameQParam)=>dispatch(cliAndImagesCruise(nameQParam))
})

  
export const  SVRCLISearchComSV = connect(mapStateToSVRCLIProps, mapDispatchToSVRCLIProps)(CliSearchBoardContainer);
let SVRCLISearchComTmp =  withCookies(SVRCLISearchComSV)

export const SVRCLISearchCom = SVRCLISearchComTmp

export const SVRCLIWithCustprofile = withCustomerCruisesHOC(SVRCLISearchCom);
/*

export const SVRCLIWithCustprofile = withCustomerSpacesHOC(SVRCLISearchCom);
*/
/*svdec15 end*/
/*sojboard invBoard

export const SVFlySearchComSV = connect(mapFlyStateToProps, mapFlyDispatchToProps)(FlySearchBoardContainer);
let SVFlySearchComTmp =  withCookies(SVFlySearchComSV)
export const SVFlySearchCom = SVFlySearchComTmp

export const FlyWithCustprofile = withCustomerFlySpacesHOC(SVFlySearchCom);



end */
/*sv searchbarbuscom ebd */
/*svmay3 end*/

/*sv invfacetbarbuscom start */

const mapStateToInvFacetBarProps =  state => {
  console.log('--*********************svgot invfacet state star')
  console.log(state)
  const {invfacetDataView,sosjournsearch} = state
  const {sv_esquery_data} = sosjournsearch
  let svmaster = {
    invfacetDataView:invfacetDataView,
      myloc:sosjournsearch.sv_esquery_data
  }
  console.log(svmaster)
  console.log(invfacetDataView)
  console.log('--*********************svgot invfacet state end')

  //return facetDataView
  return svmaster
}
const mapDispatchToPropsInvFacetBar= dispatch => ({
 getInvFacetDataDefaultFromServer:(nameQParam)=>dispatch(getInvFacetDataDefaultFromServer(nameQParam)),
 
 saveInvFacetFilterCheckSuccess:(ckData)=> dispatch(saveInvFacetFilterCheckSuccess(ckData)),
  
 sojAndImagesSojournFacet:(esQuery, sv_esquery_data)=> dispatch(sojAndImagesSojournFacet(esQuery, sv_esquery_data))
/* sojAndImagesSV:(esQuery,sojAndImagesSV)=> dispatch(sojAndImagesSV(esQuery,sojAndImagesSV)) */
 
 
})
export const InvFacetBarBusCom = connect(mapStateToInvFacetBarProps, mapDispatchToPropsInvFacetBar)(InvFacetBar);

/*sv facetbarbuscom end */
/*svjune6 start*/

/*svjune6 end*/

/*svjun25*/
/*roomdet start 


const mapStateToPropsRoom= state => {
  console.log('--*********************svgot state star')
  console.log(state)
  
  const { roomdetView} = state
  
  console.log('--*********************SVJ15 svgot state roomdetView start')
  console.log(roomdetView)
  
  console.log('--*********************sSVJ15 vgot state roomdetView end')
  
 //return sob
  return roomdetView
}
const mapDispatchToPropsRoom = dispatch => ({
  loadRoomDet:(nameQParam)=>dispatch(loadRoomDet(nameQParam)),
   addRoomNow:(rqValues)=>dispatch(addRoomNow(rqValues))
})


const RoomContainerComTmp = connect(mapStateToPropsRoom, mapDispatchToPropsRoom)(RoomContainer);

export const RoomContainerCom =RoomContainerComTmp
*/

/*svaddrdet  end*/

/*sjjun30 start*/

const mapStateToPropsSojourn= state => {
  console.log('--*********************svgot state star')
  console.log(state)
  const {sojourDetailView,sosjournsearch } = state
  console.log(sojourDetailView)
  let svmasterdetail = {
    sojourDetailView:sojourDetailView,
      myloc:sosjournsearch.sv_esquery_data
  }

  console.log('--*********************svgot state end')
  return svmasterdetail
 // return sojourDetailView
}
/*

dispatch=>({
  svWrappedfetchTaskActionCreator:function(id){
      console.log('redux sv store.dispatch ')
      dispatch(fetchTaskActionCreator(id))
  }

})
*/
const mapDispatchToPropsSojour = dispatch => ({
  svWrappedfetchTaskActionCreator:(id)=> dispatch(getSojournDetails(id)),
  svwithImagesWrappedfetchTaskActionCreator:(id)=> dispatch(sojDetailsAndImagesSV(id)),
  sojAndImagesSojournPaginate1HotelById:(nameQParamOb, sv_esquery_data)=>dispatch(sojAndImagesSojournPaginate1HotelById(nameQParamOb, sv_esquery_data)),
  //sojAndImagesSojournPaginate1HotelById
  sojDetailsAndImagesSV:(nameQParam)=>dispatch(sojDetailsAndImagesSV(nameQParam)),
  getSojournDetails:(nameQParam)=>dispatch(getSojournDetails(nameQParam))
})

let  SJInvTerrainComSV = connect(mapStateToPropsSojourn, mapDispatchToPropsSojour)(InvTerrainContainer);
export const SJInvTerrainCom =  withCookies(SJInvTerrainComSV)


export const SJInvWithSearch = withCustomerSJHotelHOC(SJInvTerrainCom);


/*sjjun30 end*/

/*sjaug1 sart*/

/**sjrewview start */


const mapStateToPropsSJPBReview= state => {
  console.log('--*********************svgot state  AUG1** sjpbreviewView star')
  console.log(state)
  const {sjpbreviewView} = state
  console.log(sjpbreviewView)
  console.log('--*********************svgot state  AUG1** sjpbreviewView end')
 
  return sjpbreviewView
}

const mapDispatchToPropsSJPBReview = dispatch => ({
  loadReviewNowSJReservationForCustId : (nameQParam, custProfile)=>dispatch(loadReviewNowSJReservationForCustId(nameQParam, custProfile)),
  loadSJReviewNow:(nameQParam)=>dispatch(loadSJReviewNow(nameQParam)),
  pbsaveTravellerSJReviewSuccess:(pt)=>dispatch(pbsaveTravellerSJReviewSuccess(pt)),
 
  sjpriceAndTexNowSecure:(nameQParam,svtv)=>dispatch(sjpriceAndTexNowSecure(nameQParam,svtv)),
  sjpriceAndTexNow:(nameQParam)=>dispatch(sjpriceAndTexNow(nameQParam))
 
})

/*
export const SVReviewTerrainCom = connect(mapStateToPropsSJReview, mapDispatchToPropsSJReview)(FinalStepPaymentReviewContainer);
*/
const SJPBReviewTerrainComSV = connect(mapStateToPropsSJPBReview, mapDispatchToPropsSJPBReview)(SJPBReviewContainer);
let SJPBReviewTerrainComTmp =  withCookies(SJPBReviewTerrainComSV)
export const SJPBReviewTerrainCom =SJPBReviewTerrainComTmp


export const SJPBReviewWithSearch = withCustomerSJPBReviewHOC(SJPBReviewTerrainCom);

/**sjrewview end */

/*sjaug1 end*/

/*sjaug3 start*/

const mapStateToSJPBProps= state => {
  console.log('--*********************svgot state star')
  console.log(state)
 
  const {sosjournsearch, locationDataView} = state
  console.log(sosjournsearch)
  console.log(locationDataView)
  console.log('--*********************svgot state end')
  const svmaster = {sosjournsearch, locationDataView}
 
  return svmaster
}
//sojAndImagesSojournPaginate
const mapDispatchToSJPBProps = dispatch => ({
  getSoDetails:(nameQParam)=>dispatch(getSoDetails(nameQParam)),
  sojAndImagesSojournMore:(esQuery,my_esqueryText)=> dispatch(sojAndImagesSojournMore(esQuery,my_esqueryText)),
  sojAndImagesSojournPaginate:(esQuery,my_esqueryText)=> dispatch(sojAndImagesSojournPaginate(esQuery,my_esqueryText)),

  sojAndImagesSojourn:(nameQParam)=>dispatch(sojAndImagesSojourn(nameQParam))
})

  
export const  SJPBSearchComSV = connect(mapStateToSJPBProps, mapDispatchToSJPBProps)(PbSearchBoardContainer);
let SJPBSearchComTmp =  withCookies(SJPBSearchComSV)

export const SJPBSearchCom = SJPBSearchComTmp
/*sjaug3 ebd*/


/*sv pbsearchbarbuscom start */
const mapStateToPbSearchBarProps =  state => {
  console.log('--*********************svgot mapStateToPbSearchBarProps star')
  console.log(state)
  const {locationDataView} = state
  console.log(locationDataView)
  console.log('--*********************svgot mapStateToPbSearchBarProps end')

  return locationDataView
}
const mapDispatchToPropsPbSearchBar= dispatch => ({
  
 //sojAndImagesSojournPaginate
  getLocationDataDefaultFromServer:(nameQParam)=>dispatch(getLocationDataDefaultFromServer(nameQParam)),
  esautocompleteNow:(esQuery)=> dispatch(esautocompleteNow(esQuery)),

  sojAndImagesSojournMore:(esQuery,my_esqueryText)=> dispatch(sojAndImagesSojournMore(esQuery,my_esqueryText)),
  sojAndImagesSojournPaginate:(esQuery,my_esqueryText)=> dispatch(sojAndImagesSojournPaginate(esQuery,my_esqueryText)),

  saveRoomSuccess:(roomData)=> dispatch(saveRoomSuccess(roomData)),
  //flyAndImagesSV:(esQuery)=> dispatch(flyAndImagesSV(esQuery)),
  sojAndImagesSojourn:(esQuery,my_esqueryText)=> dispatch(sojAndImagesSojourn(esQuery,my_esqueryText))
 
 
})
export const PbSearchBarBusCom = connect(mapStateToPbSearchBarProps, mapDispatchToPropsPbSearchBar)(PbSearchBar);



/*sv clisearchbarbuscom start */
const mapStateToCliSearchFindBarProps =  state => {
  console.log('--*********************svgot cli state star')
  console.log(state)
  /*
  const { svclisearch} = state
  const {svcli_esquery_data,svselected} = svclisearch
  */
  const {locationDataView} = state
  console.log(locationDataView)
  //console.log(locationDataView)
  console.log('--*********************svgot cli state end')
  const {locationData} = locationDataView
  let master = {
    locationData:locationData
  
  }
  console.log(master)
  return master
  //return locationDataView
}
//saveFindCliEsQueryDataSuccess
const mapDispatchToPropsCliSearchFindBar= dispatch => ({
  saveFindCliEsQueryDataSuccess:(findStateFilters)=>dispatch(saveFindCliEsQueryDataSuccess(findStateFilters)),
  /*svmar14 start 
  cliCountryCodeSV:(sojPostRqFromPage, svfly_esquery_data)=> dispatch(cliCountryCodeSV(sojPostRqFromPage, svfly_esquery_data)),
  */
  /*svmar14 end */
  cliAndImagesSV:(esQuery, svcli_esquery_data)=> dispatch(cliAndImagesSV(esQuery, svcli_esquery_data))
 /*
  getLocationDataDefaultFromServer:(nameQParam)=>dispatch(getLocationDataDefaultFromServer(nameQParam)),
  esautocompleteNow:(esQuery)=> dispatch(esautocompleteNow(esQuery)),
  saveFindEsQueryDataSuccess:(findStateFilters)=>dispatch(saveFindEsQueryDataSuccess(findStateFilters)),
  flyCountryCodeSV:(esQuery, svfly_esquery_data)=> dispatch(flyCountryCodeSV(esQuery, svfly_esquery_data)),

  flyAndImagesSV:(esQuery, svfly_esquery_data)=> dispatch(flyAndImagesSV(esQuery, svfly_esquery_data)),
  sojAndImagesSV:(esQuery)=> dispatch(sojAndImagesSV(esQuery))
 */
 
})
export const CliSearchBarBusCom = connect(mapStateToCliSearchFindBarProps, mapDispatchToPropsCliSearchFindBar)(CliSearchBar);


/*sv sflyearchbarbuscom end */



/*svdec19 start*/


const mapStateToPropsCruisedet= state => {
  console.log('--*********************svgot state star')
  console.log(state)
  const {cruiseDetailView,cruisesearch } = state
  console.log(cruiseDetailView)
  let svmasterdetail = {
    cruiseDetailView:cruiseDetailView,
      myloc:cruisesearch.svcli_esquery_data
  }

  console.log('--*********************svgot state end')
  return svmasterdetail
 // return sojourDetailView
}
const mapDispatchToPropsCruisedet = dispatch => ({
  cliAndImagesCruisePaginate1HotelById:(nameQParamOb, sv_esquery_data)=>dispatch(cliAndImagesCruisePaginate1HotelById(nameQParamOb, sv_esquery_data))
  //sojAndImagesSojournPaginate1HotelById
 
})

let  SJCliTerrainComSV = connect(mapStateToPropsCruisedet, mapDispatchToPropsCruisedet)(CliTerrainContainer);
export const SJCliTerrainCom =  withCookies(SJCliTerrainComSV)


export const SJCliWithSearch = withCustomerCruisesHOC(SJCliTerrainCom);


/*sjjun30 end*/


/**crrewview  mar18 start */

/*  state has form.svtppForm.values.members  */
const mapStateToPropsCRReview = state => {
  console.log('--*********************svgot state crreviewView star')
  console.log(state)
  const {crreviewView} = state
  console.log(crreviewView)
  console.log('--*********************svgot state crreviewView end')
 
  return crreviewView
}

const mapDispatchToPropsCRReview = dispatch => ({
  loadReviewNowCRReservationForCustId : (nameQParam, custProfile)=>dispatch(loadReviewNowCRReservationForCustId(nameQParam, custProfile)),
  loadCRReviewNow:(nameQParam)=>dispatch(loadCRReviewNow(nameQParam)),
  saveTravellerCRReviewSuccess:(pt)=>dispatch(saveTravellerCRReviewSuccess(pt)),
  /*svapr13 start */
  crSaveDocumentReviewSuccess:(pt)=>dispatch(crSaveDocumentReviewSuccess(pt)),
  
  crSaveErrorTocumentReview:(pt)=>dispatch(crSaveErrorTocumentReview(pt)),

  crSaveTocumentReviewSuccess:(pt)=>dispatch(crSaveTocumentReviewSuccess(pt)),
  /*svapr13 end*/
 
  crpriceAndTexNowSecure:(nameQParam,svtv)=>dispatch(crpriceAndTexNowSecure(nameQParam,svtv)),
  crpriceAndTexNow:(nameQParam)=>dispatch(crpriceAndTexNow(nameQParam))
 
})

/*
export const SVReviewTerrainCom = connect(mapStateToPropsCRReview, mapDispatchToPropsCRReview)(FinalStepPaymentReviewContainer);
*/
const CRReviewTerrainComSV = connect(mapStateToPropsCRReview, mapDispatchToPropsCRReview)(SJCliReviewContainer);
let CRReviewTerrainComTmp =  withCookies(CRReviewTerrainComSV)
export const CRReviewTerrainCom =CRReviewTerrainComTmp

/**sjrewview end */


// Render out products list with search feature

export const CRReviewWithSearch = withCustomerSJReviewHOC(CRReviewTerrainComTmp);
export const CRReserveWithSearch = withCustomerSJReserveHOC(CRReviewTerrainComTmp);

/**crrewview  mar18 end */


/*svjul17 fare start*/


const mapStateToPropsCruisefare= state => {
  console.log('--*********************svgot state fare mapStateToPropsCruisefare')
  console.log(state)
  const {cruiseFareView,cruisesearch } = state
  console.log(cruiseFareView)
  let svmasterdetail = {
    cruiseFareView:cruiseFareView,
      myloc:cruisesearch.svcli_esquery_data
  }

  console.log('--*********************svgot state fare  mapStateToPropsCruisefare end')
  return svmasterdetail
 // return sojourDetailView
}
const mapDispatchToPropsCruisefare = dispatch => ({
  cliAndImagesFarelById:(nameQParamOb, sv_esquery_data)=>dispatch(cliAndImagesFarelById(nameQParamOb, sv_esquery_data))
  //sojAndImagesSojournPaginate1HotelById
 
})

let  SJCliFareTerrainComSV = connect(mapStateToPropsCruisefare, mapDispatchToPropsCruisefare)(CliFareTerrainContainer);
export const SJCliFareTerrainCom =  withCookies(SJCliFareTerrainComSV)


export const SJCliFareWithSearch = withCustomerFaresHOC(SJCliFareTerrainComSV);


/*svjuly17 fare end*/